'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dataCapsule = require('data-capsule');

var _utils = require('./utils/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkerStrategy = function (_BaseStorage) {
  (0, _inherits3.default)(WorkerStrategy, _BaseStorage);

  function WorkerStrategy() {
    (0, _classCallCheck3.default)(this, WorkerStrategy);

    var _this = (0, _possibleConstructorReturn3.default)(this, (WorkerStrategy.__proto__ || (0, _getPrototypeOf2.default)(WorkerStrategy)).call(this));

    _this.workerWindow = _utils.utils.getWorkerWindow();
    return _this;
  }

  (0, _createClass3.default)(WorkerStrategy, [{
    key: 'setItem',
    value: function setItem(key, value) {
      return this.getCartService().then(function (service) {
        service.setItem(key, value);
      });
    }
  }, {
    key: 'getItem',
    value: function getItem(key) {
      return this.getCartService().then(function (service) {
        var value = service.getItem(key);
        return _promise2.default.resolve(value);
      });
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key) {
      return this.getCartService().then(function (service) {
        service.removeItem(key);
      });
    }
  }, {
    key: 'getAllItems',
    value: function getAllItems() {
      return this.getCartService().then(function (service) {
        var result = service.getAllItems();
        return _promise2.default.resolve(result);
      });
    }
  }, {
    key: 'getCartService',
    value: function getCartService() {
      var _this2 = this;

      if (this.cartService) {
        return _promise2.default.resolve(this.cartService);
      }

      if (this.workerWindow.cartService) {
        this.cartService = this.workerWindow.cartService;
        return _promise2.default.resolve(this.cartService);
      }

      return new _promise2.default(function (resolve, reject) {
        var counter = 0;
        var interval = setInterval(function () {
          _this2.workerWindow = _utils.utils.getWorkerWindow();
          if (_this2.workerWindow.cartService) {
            _this2.cartService = _this2.workerWindow.cartService;
            clearTimeout(interval);
            resolve(_this2.cartService);
          }
          counter++;
          if (counter > 60) {
            clearTimeout(interval);
            reject('Cannot get cart service from worker');
          }
        }, 1000);
      });
    }
  }]);
  return WorkerStrategy;
}(_dataCapsule.BaseStorage);

exports.default = WorkerStrategy;